import { render, staticRenderFns } from "./departmentrenter.vue?vue&type=template&id=4bd2760f&"
import script from "./departmentrenter.vue?vue&type=script&lang=js&"
export * from "./departmentrenter.vue?vue&type=script&lang=js&"
import style0 from "./departmentrenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports